import { render, staticRenderFns } from "./rr-loading-placeholder.vue?vue&type=template&id=163713a0&scoped=true&lang=pug&"
import script from "./rr-loading-placeholder.vue?vue&type=script&lang=js&"
export * from "./rr-loading-placeholder.vue?vue&type=script&lang=js&"
import style0 from "./rr-loading-placeholder.vue?vue&type=style&index=0&id=163713a0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163713a0",
  null
  
)

export default component.exports